import('jquery');
// import 'bootstrap/js/src/tooltip';
import React from 'react/cjs/react.production.min';
// import map from 'lodash/map';

export class SolutionPackageComponent extends React.Component {
  constructor(packageConfig) {
    super();

    this.packageConfig = packageConfig;

    this.state = {
      currency: null,
      term: null,
      symbol: null,
      price: null,
    };

    qs.pricing.onCurrencyPreferenceChanged(() => {
      this.updateState();
    });

    qs.pricing.onTermPreferenceChanged(() => {
      this.updateState();
    });

    this.addToEstimate = this.addToEstimate.bind(this);
  }

  async componentDidMount() {
    await this.updateState();
  }

  async updateState() {
    const currency = await qs.pricing.getCurrencyPreference();
    const currencySymbol = await qs.pricing.getCurrencySymbol(currency);

    const term = await qs.pricing.getTermPreference();
    const termDescription = term % 12 === 0
      ? `${ term / 12 }-year`
      : `${ this.state.term }-month`;

    let recurringPrice = 0;
    let oneTimePrice = 0;

    const bundles = [];

    for (const bundle of this.packageConfig.bundles) {
      bundles.push(await qs.pricing.getBundle(bundle.productLine, bundle.tier));
      const prices = await qs.pricing.getBundleStartingPrice(bundle.productLine, bundle.tier);
      recurringPrice += prices.recurringPrice;
      oneTimePrice += prices.oneTimePrice;
    }

    const bundleSummary = await this.renderBundleSummary(bundles);

    let price = 0;
    let priceSuffix = '';

    if (recurringPrice > 0) {
      price = recurringPrice;
      priceSuffix = '/mo.';
    }
    else {
      price = oneTimePrice;
      priceSuffix = '';
    }

    this.setState({
      currencySymbol,
      price,
      priceSuffix,
      bundleSummary,
    })
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
    }, 1000);
  }

  async renderBundleSummary(bundles) {
    if (!bundles) {
      return '';
    }

    const results = [];
    for (const bundle of bundles) {
      const skuSummary = await this.renderSkuSummary(bundle.productLine, bundle.skus);
      results.push((
        <li>
          <em>{bundle.productLineName}</em>
          <ul>{skuSummary}</ul>
        </li>
      ))
    }

    return results;
  }

  async renderSkuSummary(productLine, skus) {
    const results = [];
    for (const sku of skus) {
      if (sku.defaultQuantity === 0) {
        continue;
      }

      const skuDetail = await qs.pricing.getSkuDetail(productLine, sku.sku);

      results.push((
        <li>
          <span>
            {skuDetail.name}
            <img className="more-info-text" src="/assets/img/solutions/icon-info.svg" alt="Icon for more information" data-toggle="tooltip" title={skuDetail.description} width="14" height="14" />
          </span>
          <strong>
            {sku.defaultQuantity === 1 ? 'incl' : sku.defaultQuantity}
            {sku.defaultQuantity > 1 ? this.getUnitSuffix(skuDetail.unit) : ''}
          </strong>
        </li>
      ));
    }

    return results;
  }

  getUnitSuffix(unit) {
    switch (unit) {
      case 'GB':
        return 'GB';
      case 'hours':
        return 'h';
      default:
        return '';
    }
  }

  addToEstimate() {
    for (const bundle of this.packageConfig.bundles) {
      qs.pricing.estimator.addBundle(bundle.productLine, bundle.tier);
    }
    location.href = '/estimator';
  }

  render() {
    return (
      <div className="price-top">
        <span>
          <h3>{this.packageConfig.name}</h3>
          <small>{this.packageConfig.description}</small>
        </span>
        <p className="price-copy text-center">
          <em>Starting at</em>
          <span className="price">
            <em><span>{this.state.currencySymbol}</span>{new Intl.NumberFormat().format(Math.round(this.state.price))}</em>
          </span>{this.state.priceSuffix}
        </p>
        <p className="mb-0 p-0 d-print-none">
          <a role="button" onClick={this.addToEstimate} className="btn btn-primary d-block">Customize this Package</a>
        </p>
        <p className="feature-list-heading">Includes:</p>
        <ol>
          {this.state.bundleSummary}
        </ol>
      </div>
    )
  }
}
